import {ProcessadorTexto} from "./ProcessadorTexto";

export class ProcessadorCancelamentoPedidoTexto extends ProcessadorTexto {
  obtenhaComprovante(dados: any): string {
    let texto = this.centralizarLinha('PEDIDO CANCELADO')
      + this.centralizarLinha('PELO CLIENTE')
      + this.linhaComCaracter('-')
      + this.linha(`Pedido: #${dados.codigo || ''}`);

    texto += this.linhasCampo('Cliente', dados.clienteNome);
    texto += this.linhasCampo('Telefone', dados.clienteTelefone);
    texto += this.linhasCampo('Cancelado em', this.obtenhaDataCancelamento(dados.canceladoEm));

    texto += this.linhaComCaracter('-')
      + this.centralizarLinha('NAO PRODUZIR / ENTREGAR')
      + this.linha()
      + ProcessadorTexto._MARCADOR_FIM_PAPEL;

    return texto;
  }

  private linhasCampo(rotulo: string, valor: string): string {
    if(!valor) return '';

    const linhas = this.multiplasLinhas(`${rotulo}: ${valor}`, this.papel.tamanhoLinha, false);
    return linhas.map((linha: string) => this.linha(linha.trim())).join('');
  }

  private obtenhaDataCancelamento(data: string): string {
    if(!data) return '';

    const dataCancelamento = new Date(data);

    if(isNaN(dataCancelamento.getTime())) return '';

    return dataCancelamento.toLocaleString('pt-BR');
  }
}
